import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import './NextStepsCTA.css';

const OPTIMIZE_URL = new URL(process.env.REACT_APP_OPTIMIZE_URL).href;
const PROGRAM_URL = new URL(process.env.REACT_APP_PROGRAM_URL).href;

export const NextStepsCTA = () => (
  <div className="next-steps" data-testid="cta-next-steps">
    <div className="next-steps-path" data-testid="cta-optimize-path">
      <a
        href={OPTIMIZE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="next-steps-preview"
        data-testid="cta-optimize-preview-link"
        aria-label="Visit IWOptimizeMe.com (opens in a new tab)"
      >
        <img
          src="/images/site-previews/iwoptimizeme-home-960.webp"
          srcSet="/images/site-previews/iwoptimizeme-home-960.webp 960w, /images/site-previews/iwoptimizeme-home-1440.webp 1440w"
          sizes="(min-width: 1280px) 576px, (min-width: 1024px) calc(50vw - 64px), (min-width: 768px) calc(50vw - 48px), calc(100vw - 32px)"
          width="960"
          height="400"
          loading="lazy"
          decoding="async"
          alt="IWOptimizeMe homepage showing Optimize More Than One Number"
          data-testid="cta-optimize-preview-image"
        />
      </a>
      <p className="next-steps-label" data-testid="cta-optimize-label">AFTER YOUR RESULTS</p>
      <h3 className="next-steps-heading" data-testid="cta-optimize-heading">
        Your Next Step.
        <span className="next-steps-highlight">Get Optimized.</span>
      </h3>
      <p className="next-steps-description" data-testid="cta-optimize-description">
        Explore support beyond your lab results.
      </p>
      <a
        href={OPTIMIZE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="next-steps-link next-steps-link-optimize"
        data-testid="cta-optimize-link"
        aria-label="Get optimized at IWOptimizeMe.com (opens in a new tab)"
      >
        GET OPTIMIZED <ArrowUpRight size={20} aria-hidden="true" />
      </a>
      <p className="next-steps-domain" data-testid="cta-optimize-domain">IWOptimizeMe.com</p>
    </div>
    <div className="next-steps-path" data-testid="cta-program-path">
      <a
        href={PROGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="next-steps-preview"
        data-testid="cta-program-preview-link"
        aria-label="Visit IntegratedNYCAI.com (opens in a new tab)"
      >
        <img
          src="/images/site-previews/integratednycai-home-960.webp"
          srcSet="/images/site-previews/integratednycai-home-960.webp 960w, /images/site-previews/integratednycai-home-1440.webp 1440w"
          sizes="(min-width: 1280px) 576px, (min-width: 1024px) calc(50vw - 64px), (min-width: 768px) calc(50vw - 48px), calc(100vw - 32px)"
          width="960"
          height="400"
          loading="lazy"
          decoding="async"
          alt="IntegratedNYCAI homepage showing Your Health Is Connected. Your Healthcare Should Be Too."
          data-testid="cta-program-preview-image"
        />
      </a>
      <p className="next-steps-label" data-testid="cta-program-label">SEE THE BIGGER PICTURE</p>
      <h3 className="next-steps-heading" data-testid="cta-program-heading">
        Explore
        <span className="next-steps-highlight">Integrated Wellness.</span>
      </h3>
      <p className="next-steps-description" data-testid="cta-program-description">
        Discover our approach to personalized wellness.
      </p>
      <a
        href={PROGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="next-steps-link next-steps-link-program"
        data-testid="cta-program-link"
        aria-label="Explore our program at IntegratedNYCAI.com (opens in a new tab)"
      >
        OUR PROGRAM <ArrowUpRight size={20} aria-hidden="true" />
      </a>
      <p className="next-steps-domain" data-testid="cta-program-domain">IntegratedNYCAI.com</p>
    </div>
  </div>
);